"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _compose = _interopRequireDefault(require("transmute/compose"));

var _merge = _interopRequireDefault(require("transmute/merge"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _reactDnd = require("react-dnd");

var _DragDirections = _interopRequireWildcard(require("./DragDirections"));

var ITEM_TARGET = {
  drop: function drop(props, monitor) {
    if (props.onDrop != null) {
      props.onDrop(monitor.getItem());
    }
  },
  hover: function hover(props, monitor, component) {
    var clientOffset;
    var dragIndex = monitor.getItem().index;
    var hoverIndex = props.index;
    var listKey = props.listKey;
    var dragDirection = props.dragDirection; // Dragging item from a different container into this one
    // Change the list key to avoid infinite loops

    if (dragIndex === -1 || monitor.getItem().listKey !== listKey) {
      props.onAddOption(monitor.getItem(), hoverIndex, listKey);

      if (typeof props.onRemoveOption === 'function') {
        props.onRemoveOption(monitor.getItem());
      }

      monitor.getItem().index = hoverIndex;
      monitor.getItem().listKey = listKey;
      return;
    } // Don't replace items with themselves


    if (dragIndex === hoverIndex) {
      return;
    } // Determine rectangle on screen
    // eslint-disable-next-line react/no-find-dom-node


    var hoverBoundingRect = (0, _reactDom.findDOMNode)(component).getBoundingClientRect();

    if (dragDirection === _DragDirections.HORIZONTAL) {
      // Get horizontal middle
      var hoverCrossoverPoint = hoverBoundingRect.right - hoverBoundingRect.left; // Determine mouse position

      clientOffset = monitor.getClientOffset(); // Get pixels to the left

      var hoverClientX = clientOffset.x - hoverBoundingRect.left; // When dragging left, only move when the cursor is greater than 90%
      // When dragging right, only move when the cursor is less than 10%
      // Dragging right

      var draggingRight = dragIndex < hoverIndex && hoverClientX < hoverCrossoverPoint * 0.1; // Dragging left

      var draggingLeft = dragIndex > hoverIndex && hoverClientX > hoverCrossoverPoint * 0.9;

      if (draggingLeft || draggingRight) {
        return;
      }
    } else {
      // Get vertical middle
      var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2; // Determine mouse position

      clientOffset = monitor.getClientOffset(); // Get pixels to the top

      var hoverClientY = clientOffset.y - hoverBoundingRect.top; // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards

      var draggingDown = dragIndex < hoverIndex && hoverClientY < hoverMiddleY; // Dragging upwards

      var draggingUp = dragIndex > hoverIndex && hoverClientY > hoverMiddleY;

      if (draggingDown || draggingUp) {
        return;
      }
    } // Time to actually perform the action


    props.onMove(dragIndex, hoverIndex, monitor.getItem()); // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.

    monitor.getItem().index = hoverIndex;
  }
};

var defaultData = function defaultData() {
  return {};
};

function _default(itemType) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultData;
  var override = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var itemTypeSource;
  var itemTypeTarget;

  if ((0, _typeof2.default)(itemType) === 'object') {
    itemTypeSource = itemType.itemTypeSource;
    itemTypeTarget = itemType.itemTypeTarget;
  } else {
    itemTypeTarget = itemType;
    itemTypeSource = itemType;
  }

  var ITEM_SOURCE = (0, _merge.default)(override, {
    beginDrag: function beginDrag(props) {
      return {
        index: props.index,
        originalIndex: props.index,
        listKey: props.listKey,
        data: data(props),
        useCustomDragLayer: props.useCustomDragLayer
      };
    },
    endDrag: function endDrag(props, monitor) {
      var _monitor$getItem = monitor.getItem(),
          originalIndex = _monitor$getItem.originalIndex,
          index = _monitor$getItem.index;

      var didDrop = monitor.didDrop();

      if (!didDrop) {
        props.onMove(index, originalIndex, monitor.getItem());

        if (props.onInvalidDrop != null) {
          props.onInvalidDrop(index, originalIndex, monitor.getItem());
        }
      }
    }
  });
  return function (WrappedComponent) {
    var componentName = WrappedComponent.displayName || WrappedComponent.name;

    var DnDListWrapper = _react.default.createClass({
      displayName: "DnDListWrapper(" + componentName + ")",
      propTypes: {
        index: _react.PropTypes.number.isRequired,
        dragDirection: _react.PropTypes.oneOf(Object.keys(_DragDirections.default))
      },
      getDefaultProps: function getDefaultProps() {
        return {
          dragDirection: _DragDirections.VERTICAL
        };
      },
      render: function render() {
        return _react.default.createElement(WrappedComponent, this.props);
      }
    });

    return (0, _compose.default)((0, _reactDnd.DragSource)(itemTypeSource, ITEM_SOURCE, function (connect, monitor) {
      return {
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging(),
        connectDragPreview: connect.dragPreview(),
        itemTypeSource: monitor.internalMonitor.store.getState().dragOperation.itemType
      };
    }), (0, _reactDnd.DropTarget)(itemTypeTarget, ITEM_TARGET, function (connect, monitor) {
      return {
        connectDropTarget: connect.dropTarget(),
        isOver: monitor.isOver(),
        isOverCurrent: monitor.isOver({
          shallow: true
        })
      };
    }))(DnDListWrapper);
  };
}

module.exports = exports.default;